import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { Toaster as Sonner, toast } from "sonner";
import type { ToasterProps } from "sonner";

import { useTheme } from "@/design-system/providers/ThemeProvider";
import {
  toastActionClassName,
  toastCloseClassName,
  toastDescriptionClassName,
  toastSurfaceClassName,
  toastTitleClassName,
} from "@/components/ui/toast";

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme();

  return (
    <Sonner
      closeButton
      theme={resolvedTheme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: `group toast ${toastSurfaceClassName} before:bg-primary/20 data-[type=error]:border-destructive/20 data-[type=error]:before:bg-destructive`,
          title: toastTitleClassName,
          description: toastDescriptionClassName,
          content: "grid gap-1 pr-3",
          icon: "mt-0.5 shrink-0 text-current",
          closeButton: toastCloseClassName,
          actionButton: toastActionClassName,
          cancelButton:
            "inline-flex h-9 shrink-0 items-center justify-center rounded-md border border-input bg-background px-3.5 text-[0.8125rem] font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
          error: "border-destructive/20 before:bg-destructive",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
